import React from "react";
import "../../styles/Home.css";
import rabbit from "../../assets/images/ramblinrabbit.jpg";

export default function Home() {
    return (
        <div className="container-home">
            <p className="overwhelmed-text">RAMSFORD IS A BIT OVERWHELMED, HE WILL BE BACK SOON</p>
            <img src={rabbit} alt="ramblin rabbit" className="rabbit-img" />
        </div>
    )
}
